"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Loader = _interopRequireDefault(require("../Loader"));

var _GridCell = _interopRequireDefault(require("./GridCell"));

var _tKeys = require("./tKeys");

var _helpers = require("./helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialDnD = {
  dragged: {},
  draggedOver: {},
  dragCanDrop: false
};

var GridBody = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(GridBody, _React$PureComponent);

  var _super = _createSuper(GridBody);

  function GridBody() {
    var _this;

    _classCallCheck(this, GridBody);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", _objectSpread({}, initialDnD));

    _defineProperty(_assertThisInitialized(_this), "handleSelectItem", function (item) {
      return function (e) {
        return _this.props.selectItem(item, e);
      };
    });

    _defineProperty(_assertThisInitialized(_this), "preventClickToCheckbox", function (event) {
      // If you do not stop the ascent of the event, it will call the function SelectItem().
      event.stopPropagation();
    });

    _defineProperty(_assertThisInitialized(_this), "getRowId", function (row) {
      if (!row) return;
      var idKey = (0, _helpers.getIdKey)(_this.props.params);
      return row[idKey];
    });

    _defineProperty(_assertThisInitialized(_this), "getClosestTr", function (event) {
      return event.target.closest('tr');
    });

    _defineProperty(_assertThisInitialized(_this), "findRow", function (id) {
      return _this.props.data.find(function (item) {
        return _this.getRowId(item) === id;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleRowDragStart", function (event) {
      var tr = _this.getClosestTr(event); // _id for internal condition


      var _id = Number(tr.dataset.id);

      var dragged = _this.findRow(_id);

      _this.setState({
        dragged: _objectSpread(_objectSpread({}, dragged), {}, {
          _id: _id
        })
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleRowDragEnter", function (event) {
      var _this$state = _this.state,
          dragged = _this$state.dragged,
          stateOver = _this$state.draggedOver; // dragging NOT a row, so do nothing

      if (!dragged._id) return;

      var overTr = _this.getClosestTr(event);

      var overTrId = Number(overTr.dataset.id);
      if (_this.getRowId(stateOver) === overTrId) return;

      var draggedOver = _this.findRow(overTrId);

      var dragCanDrop = _this.handleDragCanDrop(dragged, draggedOver);

      _this.setState({
        draggedOver: draggedOver,
        dragCanDrop: dragCanDrop
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleRowDragOver", function (event) {
      event.persist();

      if (event.preventDefault) {
        event.preventDefault(); // Necessary. Allows us to drop.
      }

      var dragCanDrop = _this.state.dragCanDrop;
      event.dataTransfer.dropEffect = dragCanDrop ? 'move' : 'none';
    });

    _defineProperty(_assertThisInitialized(_this), "handleRowDragEnd", function () {
      var _this$state2 = _this.state,
          dragged = _this$state2.dragged,
          draggedOver = _this$state2.draggedOver,
          dragCanDrop = _this$state2.dragCanDrop;
      var rowDnD = _this.props.params.rowDnD;

      if (dragCanDrop && rowDnD && rowDnD.onDragEnd) {
        rowDnD.onDragEnd(dragged, draggedOver);
      }

      _this.setState(initialDnD);
    });

    _defineProperty(_assertThisInitialized(_this), "handleDragCanDrop", function (dragged, draggedOver) {
      var rowDnD = _this.props.params.rowDnD;
      return rowDnD && rowDnD.canDrop ? rowDnD.canDrop(dragged, draggedOver) : false;
    });

    return _this;
  }

  _createClass(GridBody, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          data = _this$props.data,
          params = _this$props.params,
          groups = _this$props.groups,
          saveGridBodyRef = _this$props.saveGridBodyRef,
          selected = _this$props.selected,
          multiSelected = _this$props.multiSelected,
          firstField = _this$props.firstField,
          lastField = _this$props.lastField,
          resizedColumnName = _this$props.resizedColumnName,
          forceWidth = _this$props.forceWidth,
          toggleRowVisibility = _this$props.toggleRowVisibility,
          fixedWidths = _this$props.fixedWidths;

      if (params.loading) {
        return /*#__PURE__*/_react["default"].createElement(_Loader["default"], null);
      }

      if (!data || !data.length) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "no-items"
        }, /*#__PURE__*/_react["default"].createElement("span", null, params.t((0, _tKeys.getTKey)(params.tKeys, 'noItems'))));
      }

      var draggedOver = this.state.draggedOver;

      var _ref = groups || {},
          handleCheck = _ref.handleCheck,
          checkedItems = _ref.checkedItems;

      var fieldsValues = Object.keys(params.fields);
      var selectedId = this.getRowId(selected);
      var isDraggable = Boolean(params.rowDnD);
      var withoutColumnsMenu = params.options.withoutColumnsMenu;
      return /*#__PURE__*/_react["default"].createElement("table", {
        className: "table-grid grid-static-body",
        cellSpacing: "0",
        ref: saveGridBodyRef
      }, /*#__PURE__*/_react["default"].createElement("tbody", null, data.map(function (item) {
        var id = _this2.getRowId(item);

        return /*#__PURE__*/_react["default"].createElement("tr", {
          key: id,
          data: id,
          className: (0, _classnames["default"])({
            selected: (id || id === 0 && item.children) && (multiSelected.includes(id) || selectedId === id || id === _this2.getRowId(draggedOver))
          }),
          onClick: _this2.handleSelectItem(item),
          onDoubleClick: params.tr && params.tr.dblClick && params.tr.dblClick(item),
          draggable: isDraggable,
          onDragStart: _this2.handleRowDragStart,
          onDragEnter: _this2.handleRowDragEnter,
          onDragOver: _this2.handleRowDragOver,
          onDragEnd: _this2.handleRowDragEnd,
          "data-id": id
        }, groups && /*#__PURE__*/_react["default"].createElement("td", {
          onClick: _this2.preventClickToCheckbox,
          className: "grid-cell-checkbox",
          "data-name": "checkbox"
        }, /*#__PURE__*/_react["default"].createElement("input", {
          type: "checkbox",
          value: id,
          onChange: handleCheck,
          checked: checkedItems.includes(id)
        })), fieldsValues.map(function (field, k) {
          return /*#__PURE__*/_react["default"].createElement(_GridCell["default"], {
            key: field,
            lastField: lastField,
            firstField: firstField,
            toggleRowVisibility: toggleRowVisibility,
            value: item[field] === 0 ? 0 : item[field] || '',
            item: params.fields[field],
            id: id,
            name: field,
            data: item,
            t: params.t,
            resizing: !!resizedColumnName,
            forceWidth: field === resizedColumnName && forceWidth ? forceWidth : null,
            fixedWidth: fixedWidths ? fixedWidths[field] : null,
            elementIconClass: params.elementIconClass,
            folderIconClass: params.folderIconClass
          });
        }), params.lastColumn ? params.lastColumn(item) : !withoutColumnsMenu && /*#__PURE__*/_react["default"].createElement("td", {
          className: "grid-cell-hidemenu",
          "data-name": "_columns-hide-menu"
        }));
      })));
    }
  }]);

  return GridBody;
}(_react["default"].PureComponent);

GridBody.propTypes = {
  data: _propTypes["default"].array,
  params: _propTypes["default"].object,
  groups: _propTypes["default"].object,
  saveGridBodyRef: _propTypes["default"].func,
  selected: _propTypes["default"].object,
  multiSelected: _propTypes["default"].array,
  selectItem: _propTypes["default"].func,
  toggleRowVisibility: _propTypes["default"].func,
  firstField: _propTypes["default"].string,
  lastField: _propTypes["default"].string,
  fixedWidths: _propTypes["default"].object,
  resizedColumnName: _propTypes["default"].string
};
GridBody.defaultProps = {
  data: [],
  params: {},
  selected: {}
};
var _default = GridBody;
exports["default"] = _default;